export default {"profile":"Jr2yD","betDetails":"yFWEV","titleCell":"ehp5O","titleHeading":"uLG7h","titleText":"cyNKk"};